/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import autoBind from 'react-autobind'
import moment from 'moment'
import R from 'ramda'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Card, MenuItem, Checkbox } from 'material-ui'

import { AutoCompleteField, SelectField, GoogleAutoCompleteField } from 'generic/form'
import { makeCancelable } from 'utils/makeCancelable'
import { getDateTime } from 'utils/date'
import { selectHelper, selectHelperMulti } from 'generic/form/selectHelper'
import InterpreterSearchBottom from './search/InterpreterSearchBottom'
import InterpreterSearchTop from './search/InterpreterSearchTop'
import AdditionalServiceSearch from './search/AdditionalServiceSearch'

import * as constants from 'constants/Prestation'
import * as applicationConstants from 'constants/Applicant'

import * as actions from 'actions/ApplicantPrestation'
import * as languageActions from 'actions/Language'
import * as interpreterActions from 'actions/Interpreter'

class InterpreterSearch extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)

    this.state = {
      prestationSearchAutocomplete: [],
      autocompleteLoading: false,
      languages: [],
      isPastPrestation: false,
      similarPrestation: undefined,
      autocompleteText: undefined,
      errors: {},
      calculationMap: false
    }
  }

  componentDidMount() {
    const { prestation, history } = this.props
    const { interpreter, uid, languages, is_interpreter_visible } = prestation
    const isDuplicate = history.location.params && (history.location.params.duplicate || history.location.params.prestation)

    if (uid) {
      this.handleShowDetails()
    }

    if(uid || isDuplicate) {
      this.setState({
        autocompleteText: (interpreter && interpreter.identities.length && is_interpreter_visible)
          ? `${interpreter.identities[0].first_name} ${interpreter.identities[0].last_name}`
          : languages[0].value
      })

      this.handleBuildLanguagesOrigins(languages, languages[0].value)
    }

    if (isDuplicate) {
      if (interpreter && interpreter.uid && is_interpreter_visible) {
        this.handlePrestationSearchAutocomplete({
          type: constants.INTERPRETER_TYPE,
          interpreter_uid: interpreter.uid
        })
      }

      this.props.handlePrestationChange('interpreter', undefined)
    }
  }

  componentDidUpdate(prevProps) {
    const prestation = this.props.prestation

    if (prestation &&
        !prestation.id &&
        prestation.ordered_date &&
        prestation.ordered_start_time &&
        prestation.ordered_end_time &&
        prestation.ordered_date.length === 10 &&
        prestation.ordered_start_time.length === 5 &&
        prestation.ordered_end_time.length === 5 &&
        (prestation.ordered_date !== prevProps.prestation.ordered_date ||
         prestation.ordered_start_time !== prevProps.prestation.ordered_start_time ||
         prestation.ordered_end_time !== prevProps.prestation.ordered_end_time ||
         prestation.applicant !== prevProps.prestation.applicant)) {
          actions.similarPrestation(prestation.ordered_date, prestation)
            .then((result) => {
              this.setState({
                similarPrestation: result.data.objects.objects.length
                  ? result.data.objects.objects[0].id
                  : undefined
              })
            })
        }
  }

  handleShowDetails () {
    const prestation = this.props.prestation

    let isPastPrestation, submitPrestation = !!prestation.uid || false
    let interpreterListVisible = this.props.prestation.uid ? true : false
    let conditionDisplay = !prestation.uid &&
                           prestation.ordered_date &&
                           prestation.ordered_date.length === 10 &&
                           (prestation.languages.length === 1 ||
                            (prestation.choosenInterpreter &&
                             prestation.languages.length === 1))

    if (prestation.invoice_only_additional_services) {
      conditionDisplay = conditionDisplay &&
                         prestation.invoice_only_additional_services &&
                         prestation.additional_services
    } else {
      conditionDisplay = conditionDisplay &&
                         prestation.ordered_start_time &&
                         prestation.ordered_start_time.length === 5 &&
                         prestation.ordered_end_time &&
                         prestation.ordered_end_time.length === 5 &&
                         prestation.address.address &&
                         prestation.address.address !== ''
    }

    if (conditionDisplay) {
      const dateTime = getDateTime(moment(prestation.ordered_date, 'YYYY-MM-DD'),
                                   moment(prestation.ordered_start_time, 'HH:mm'))

        submitPrestation = true

      if (moment(dateTime).isBefore(moment())) {
        interpreterListVisible = this.props.isStaff &&
                                 prestation.choosenInterpreter
        isPastPrestation = true
        submitPrestation = this.props.isStaff && !!prestation.choosenInterpreter

        if (this.props.isStaff &&
            prestation.choosenInterpreter) {
          this.props.handlePrestationChange('interpreter', {uid: prestation.choosenInterpreter})
        }

      } else {
        interpreterListVisible = true
      }
    }

    this.props.handleFormChange('submitPrestation', submitPrestation)
    this.props.handleFormChange('updateInterpreterSearch', interpreterListVisible)
    this.props.handleFormChange('interpreterListVisible', interpreterListVisible)
    this.setState({
      isPastPrestation: isPastPrestation,
      submitPrestation: submitPrestation,
      similarPrestation: false
    })
  }

  handleChange(e, value) {
    new Promise((resolve, reject) => {
      resolve(this.props.handlePrestationChange(e.target.name, value))
    })
    .then(() => {
      this.handleShowDetails()
    })
  }

  handleBuildLanguagesOrigins(languageSet, searchText) {
    let languages = []
    console.log("languageSet:", languageSet)
    languageSet.forEach((language) => {
      languages.push({
        type: constants.LANGUAGE_TYPE,
        language_uid: language.uid,
        value: language.value
      })

      if (language.value === searchText &&
          language.nationalities.length) {
        let origins = []
        const nationalities = language.nationalities.map(nationality => nationality.uid)

        this.props.origines.map((origin) => {
          if (nationalities.includes(origin.uid)) {
            origins.push(origin)
          }
        })

        this.props.handleFormChange('origins', origins)
      }
    })
    console.log("languages:", languages)
    return languages
  }

  handleBuildOriginsLanguages(languageSet, searchText) {
    let origins = []

    languageSet.forEach((language) => {
      const origin = language.nationalities.find((origin) => {
        return origin.nationality.toUpperCase().startsWith(searchText.toUpperCase())
      })

      if (origin) {
        origins.push({
          type: constants.COUPLE_NATIONATLITY_LANGUAGE_TYPE,
          language_uid: language.uid,
          origine_uid: origin.uid,
          value: language.value + ', ' + origin.nationality
        })
      }
    })

    return origins
  }

  handleBuildInterpreters(interpreterSet) {
    let interpreters = []

    interpreterSet.forEach((interpreter) => {
      const name = interpreter.identities[0].first_name + ' ' + interpreter.identities[0].last_name
      interpreters.push({
        type: constants.INTERPRETER_TYPE,
        interpreter_uid: interpreter.uid,
        value: name
      })
    })

    return interpreters
  }

  handleInterpreterSearch(searchText, dataSource) {
    this.setState({
      languages: [],
      autocompleteLoading: true,
      autocompleteText: searchText,
      errors: {
        ...this.state.errors,
        autocomplete: this.props.intl.formatMessage(constants.messages.GLOBAL_AUTOCOMPLETE_MESSAGE)
      }
    })

    this.props.handlePrestationChange('languages', [])

    this.props.handleFormChange('submitPrestation', false)
    this.props.handleFormChange('interpreterListVisible', false)

    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }

    this.timeout = setTimeout(() => {
      if (this.language || this.interpreter) {
        this.language.cancel()
        this.interpreter.cancel()
      }

      this.language = makeCancelable(languageActions.getLanguagesByLanguage(searchText))
      this.interpreter = makeCancelable(interpreterActions.getInterpreters(searchText))

      Promise.all([
        this.language.promise,
        this.interpreter.promise
      ]).then((results) => {
        const languages = this.handleBuildLanguagesOrigins(results[0], searchText)
        const interpreters = this.handleBuildInterpreters(results[1])

        this.setState({
          prestationSearchAutocomplete: languages.concat(interpreters),
          autocompleteLoading: false
        })
      })

      this.timeout = null
    }, 300)
  }

  handlePrestationSearchAutocomplete(chosenRequest) {
    this.props.handlePrestationChange('choosenInterpreter', undefined)
    this.props.handlePrestationChange('preferred_nationality_origin', undefined)
    this.props.handlePrestationChange('languages', [])

    this.props.handleFormChange('origins', [])

    this.setState({
      errors: {},
      languages: []
    })

    if (chosenRequest.type === constants.INTERPRETER_TYPE) {
      this.props.handlePrestationChange('choosenInterpreter', chosenRequest.interpreter_uid)

      interpreterActions.getInterpreter(this.props.prestation.choosenInterpreter)
        .then((interpreter) => {
          this.setState({
            languages: interpreter.language_set,
            errors: {
              ...this.state.errors,
              languages: interpreter.language_set.length > 1 ? this.props.intl.formatMessage(constants.messages.STEP_ONE_SEVERAL_LANGUAGES) : undefined
            }
          })

          this.props.handleFormChange('origins', [interpreter.nationality_origin])
          this.props.handlePrestationChange('selected_interpreters', [interpreter])

          if (this.props.prestation.confirmAuto || this.props.prestation.validation) {
            this.props.handlePrestationChange('interpreter', {uid: interpreter.uid})
          }

          if (interpreter.language_set.length === 1) {
            this.props.handlePrestationChange('languages', interpreter.language_set)
          }

          this.props.handlePrestationChange('preferred_nationality_origin', interpreter.nationality_origin)
          this.props.handlePrestationChange('preferred_sex', interpreter.identities[0].sex)

          let skill = []
          if (interpreter.skills.length === 1) {
            skill = interpreter.skills
          }

          this.props.handlePrestationChange('preferred_skills', skill)

          let qualification = []
          if (interpreter.qualifications.length === 1) {
            qualification = interpreter.qualifications
          }

          this.props.handlePrestationChange('preferred_qualifications', qualification)
        })
        .then(() => {
          this.handleShowDetails()
        })
    } else {
      this.props.handlePrestationChange('confirmAuto', undefined)
      this.props.handlePrestationChange('interpreter', undefined)
      this.props.handlePrestationChange('selected_interpreters', [])
      this.props.handlePrestationChange('languages', [])
      this.props.handlePrestationChange('preferred_nationality_origin', undefined)
      this.props.handlePrestationChange('preferred_sex', undefined)
      this.props.handlePrestationChange('preferred_skills', [])
      this.props.handlePrestationChange('preferred_qualifications', [])

      selectHelperMulti(chosenRequest.language_uid, this.props.languages, this.props.handlePrestationChange, 'languages')
      if (chosenRequest.origine_uid) {
        selectHelper(chosenRequest.origine_uid, this.props.origines, this.props.handlePrestationChange, 'preferred_nationality_origin')
        selectHelperMulti(chosenRequest.origine_uid, this.props.origines, this.props.handleFormChange, 'origins')
      }

      this.handleShowDetails()
    }
  }

  handleDisableApplicantModification () {
    if (this.props.prestation.invoice_only_additional_services &&
        !this.props.prestation.id) {
      return true
    }

    if (!this.props.prestation.id) {
      return false
    }

    const prestationStep = this.props.prestation.workflow_objects[0].step_name

    return (prestationStep === constants.CANCELLED_PRESTATION_STATUS ||
            prestationStep === constants.TO_VALIDATE_PRESTATION_STATUS ||
            prestationStep === constants.VALIDATED_PRESTATION_STATUS) &&
            !this.props.isStaff
  }

  handleSelectLanguageMultiChange (event, index, value, sourceKey) {
    new Promise((resolve, reject) => {
      selectHelperMulti(value, this.props.languages, this.props.handlePrestationChange, 'languages')
      this.setState({
        errors: {
          languages: undefined
        }
      })
      resolve()
    }).then(() => {
      this.handleShowDetails()
    })
  }

  async handleSelectPrestationTypeChange(event, index, value, sourceKey) {
    await selectHelper(value, this.props[sourceKey], this.props.handlePrestationChange, event.target.name)

    let interpreterTravelled = true
    if ([constants.PRESTATION_TYPE_PHONE_UID, constants.PRESTATION_TYPE_VIDEO_UID].indexOf(value) !== -1) {
      interpreterTravelled = false
    }

    this.props.handlePrestationChange('interpreter_travelled', interpreterTravelled)
    this.props.handleFormChange('updateInterpreterSearch', true)
  }

  async handleAddressAutocomplete (place, formatted) {
    if (!formatted) {
      return
    }

    await this.props.handlePrestationChange('address', {'address': formatted})
    await this.props.handleFormChange('updateInterpreterSearch', false)
  }

  handleAddressChange (event) {
    this.props.handlePrestationChange('address', {'address': event.target.value || undefined})
  }

  handleOnlyAdditionalServicesChange(event, value) {
    let interpreterTravelled = true
    let prestationType = this.props.prestationTypes.find(
      prestationType => prestationType.uid === constants.DEFAULT_PRESTATION_TYPE
    )

    if (value) {
      interpreterTravelled = false
      prestationType = this.props.prestationTypes.find(
        prestationType => prestationType.uid === constants.PRESTATION_TYPE_MEDIATION_UID
      )
    }

    const prestation = {
      ...this.props.prestation,
      prestation_type: prestationType,
      interpreter_travelled: interpreterTravelled,
      ordered_start_time: value ? moment('23:55', 'HH:mm').format('HH:mm') : undefined,
      ordered_end_time: value ? moment('23:59', 'HH:mm').format('HH:mm') : undefined,
      additional_services: this.props.prestation.id
        ? this.props.prestation.additional_services
        : undefined,
      [event.target.name]: value
    }

    const promise = new Promise( (resolve, reject) => {
      resolve(this.props.handleFormChange('prestation', prestation))
    })

    promise.then(() => {
      this.handleShowDetails()
    })
  }

  render() {
    const prestation = this.props.prestation
    const meta = prestation && prestation.meta ? prestation.meta.fields : {}

    return (
      <Card
        style={{
          paddingLeft: 5,
          paddingRight: 5,
          paddingBottom: 5,
          minHeight: 200
        }}
      >
        <div className='row'>
          <div className='col-md-5 col-xs-12'>
            <AutoCompleteField
              className='autocomplete'
              meta={{mandatory: true}}
              placeholderMandatory={true}
              listStyle={{width: '100%', maxHeight: 200, overflow: 'auto'}}
              textFieldStyle={styles.fontText}
              floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_ONE_AUTOCOMPLETE)}
              searchText={this.state.autocompleteText}
              disabled={this.props.prestation.uid}
              openOnFocus={true}
              fullWidth={true}
              dataSource={this.state.prestationSearchAutocomplete}
              dataSourceConfig={{text: 'value', value: 'value'}}
              onUpdateInput={this.handleInterpreterSearch}
              onNewRequest={this.handlePrestationSearchAutocomplete}
              errorText={this.state.errors ? this.state.errors['autocomplete'] : undefined}
              loading={this.state.autocompleteLoading}
            />
          </div>

          {
            prestation.invoice_only_additional_services &&
            prestation.prestation_type.uid === constants.PRESTATION_TYPE_MEDIATION_UID
              ? <AdditionalServiceSearch
                prestation={prestation}
                handleDateFormatChange={this.props.handleDateFormatChange}
                handleDateChange={this.props.handleDateChange}
                handleShowDetails={this.handleShowDetails}
                errors={this.props.errors}
                handlePrestationChange={this.props.handlePrestationChange}
              />
              : <InterpreterSearchTop
                prestation={prestation}
                handleDateFormatChange={this.props.handleDateFormatChange}
                handleDateChange={this.props.handleDateChange}
                handleTimeChange={this.props.handleTimeChange}
                handleTimeFormatChange={this.props.handleTimeFormatChange}
                handleShowDetails={this.handleShowDetails}
                errors={this.props.errors}
              />
          }
        </div>

        <div className='row'>
          <div className='col-md-5 col-xs-12'>
            {
              this.state.languages.length &&
              this.state.languages.length > 1
                ? <SelectField
                  meta={meta.languages}
                  name='languages'
                  sourceKey='languages'
                  value={prestation.languages.length > 0 ? prestation.languages[0].uid : undefined}
                  onChange={this.handleSelectLanguageMultiChange}
                  floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_ONE_LANGUE)}
                  errorText={this.state.errors ? this.state.errors['languages'] : undefined}
                  style={styles.fontText}
                >
                  {
                    this.state.languages.map((language, i) => (
                      <MenuItem
                        primaryText={language.value}
                        value={language.uid}
                        key={i}
                      />
                    ))
                  }
                </SelectField>
                : undefined
            }
          </div>

          <div className='col-md-7 col-xs-12'>
            <SelectField
              meta={meta.prestation_type}
              name='prestation_type'
              sourceKey='prestationTypes'
              value={R.path(['prestation_type', 'uid'], prestation)}
              onChange={this.handleSelectPrestationTypeChange}
              floatingLabelText={this.props.intl.formatMessage(constants.messages.TYPE_PRESTATION_LABEL)}
              disabled={this.handleDisableApplicantModification()}
              style={styles.fontText}
              disabled={
                R.path(['invoice_only_additional_services'], prestation) &&
                R.path(['prestation_type', 'uid'], prestation) === constants.PRESTATION_TYPE_MEDIATION_UID
              }
            >
              {
                this.props.prestationTypes.map((type, i) => (
                  <MenuItem
                    key={i}
                    primaryText={type.value}
                    value={type.uid}
                    style={styles.fontText}
                  />
                ))
              }
            </SelectField>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-5 col-xs-12'>
            {
              applicationConstants.APPLICANT_ADDITIONAL_SERVICES.indexOf(R.path(['applicant', 'aba_code'], prestation)) !== -1 ||
              this.props.isStaff
                ? <Checkbox
                  name='invoice_only_additional_services'
                  style={{paddingTop: 25, width: '100%'}}
                  labelStyle={styles.fontText}
                  label={this.props.intl.formatMessage(constants.messages.STEP_THREE_INVOICE_ONLY_ADDITIONAL_SERVICES_LABEL)}
                  checked={prestation.invoice_only_additional_services}
                  onCheck={this.handleOnlyAdditionalServicesChange}
                  disabled={!!prestation.uid}
                />
                : undefined
            }
          </div>

          <div className='col-md-7 col-xs-12'>
            {
              (prestation.invoice_only_additional_services &&
               prestation.prestation_type.uid === constants.PRESTATION_TYPE_MEDIATION_UID) ||
              [
                constants.PRESTATION_TYPE_PHONE_UID,
                constants.PRESTATION_TYPE_VIDEO_UID
              ].indexOf(prestation.prestation_type.uid) !== -1
                ? undefined
                : <GoogleAutoCompleteField
                  name='address'
                  meta={meta.address}
                  value={R.path(['address', 'address'], prestation)}
                  onChange={this.handleAddressChange}
                  onBlur={() => this.props.handleFormChange('updateInterpreterSearch', true)}
                  onKeyDown={(event) => {
                    if (event.keyCode === 13) {
                      this.props.handleFormChange('updateInterpreterSearch', true)
                    }
                  }}
                  handleAutocomplete={this.handleAddressAutocomplete}
                  disabled={this.handleDisableApplicantModification()}
                  floatingLabelText={this.props.intl.formatMessage(constants.messages.PRESTATION_LOCATION)}
                  floatingLabelStyle={styles.fontText}
                  inputStyle={styles.fontText}
                  placeholderMandatory={true}
                  errorText={R.path(['errors', 'address.address'], prestation)}
                />
            }
          </div>
        </div>

        <InterpreterSearchBottom
          prestation={prestation}
          isStaff={this.props.isStaff}
          isPastPrestation={this.state.isPastPrestation}
          similarPrestation={this.state.similarPrestation}
          handleChange={this.handleChange}
          handlePrestationChange={this.props.handlePrestationChange}
          handleFormChange={this.props.handleFormChange}
          handleShowDetails={this.handleShowDetails}
        />
      </Card>
    )
  }
}

const mapStateToProps = (state) => ({
  languages: state.ApplicantPrestation.languages,
  origines: state.ApplicantPrestation.origines,
  prestationTypes: state.ApplicantPrestation.prestationTypes,
})

const mapActionsToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
})

const styles = {
  fontText: {
    fontSize: 14
  },
}

export default withRouter(
  connect(mapStateToProps, mapActionsToProps)
  (injectIntl(InterpreterSearch))
)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/creation/InterpreterSearch.js